import React, {Component} from 'react';
import { connect } from 'react-redux';
import { getFormValues , reduxForm } from 'redux-form';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import DataSection from '../../comps/DataSection/DataSection';
import questions from '../config/companyProfileQuestions.json'
// import geoPolData from '../config/geoPolData';
import Heading from '@react/react-spectrum/Heading/js/Heading';
import { Translate } from 'react-redux-i18n';
import SaveNExit from './save_n_ext';

class Questionnaire extends Component{ 

    constructor()
    {
        super();
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {}
        }
    }

    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        this.setState({sectionValidation:sectionValidation});
    }
    
    render(){
        if (!this.props.isSaveAndExit) {
        this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
        const formName = 'uplevelRenewal';
        let sections = []
        Object.keys(questions).map((key) => {
            if(Array.isArray(questions[key]))
            {
                sections.push(
                    <GridRow>
                        <GridColumn size={[12,12,12,12]} >
                            <DataSection formStates={this.props.formStates} form={formName} field={questions[key]} sectionName={key} updateValidation={this.updateValidation}/>
                        </GridColumn>
                    </GridRow>);
            }
            else
            {
                
                let columns = []
                for(let i=0;i<questions[key]["noOfColumns"];i++)
                {
                    columns.push(
                    <GridColumn size={ questions[key]["size"] ? questions[key]["size"][i] : [12,12,12,12]}>
                        <DataSection formStates={this.props.formStates} form={formName} 
                        field={questions[key]["fields"].slice(i*questions[key]["fields"].length/questions[key]["noOfColumns"],(i+1)*questions[key]["fields"].length/questions[key]["noOfColumns"])} 
                        sectionName={key} updateValidation={this.updateValidation}/>
                    </GridColumn>
                    )
                }
                sections.push(
                    <GridRow>
                        {columns}
                    </GridRow>);
            }
            return null;
        });
        
        return <div>
            <Grid>  
                <GridRow>
                    <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]}>
                        <Heading className = "textBold" variant="pageTitle"><Translate value="uplevelRenewal.OnbrdPartnerFinderInfoHeader" /></Heading>
                        <br/>
                        <Heading variant="subtitle1"><Translate value="uplevelRenewal.OnbrdPartnerFinderInfoBusProfSection" /></Heading>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section1} sectionName="section1" updateValidation={this.updateValidation}/>
                            </GridColumn>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section2} sectionName="section2" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <GridRow>
                            <GridColumn size={[12,12,12,12]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section3} sectionName="section3" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section4} sectionName="section4" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <GridRow>
                            <GridColumn size={[12,12,12,12]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section5} sectionName="section5" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <br/>
                        <Heading variant="subtitle1"><Translate value="uplevelRenewal.OnbrdPartnerFinderOrgSizeSection" /></Heading>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section6} sectionName="section6" updateValidation={this.updateValidation}/>
                            </GridColumn>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section7} sectionName="section7" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <br/>
                        <Heading variant="subtitle1"><Translate value="uplevelRenewal.OnbrdPartnerFinderCustSegmentSection" /></Heading>
                        <b><Translate value="uplevelRenewal.AcctCustomerSegmentErrorMsg" /></b>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section8} sectionName="section8" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <br/>
                        <Heading variant="subtitle1"><Translate value="uplevelRenewal.OnbrdPartnerFinderProdExpSection" /></Heading>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section9} sectionName="section9" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <br/>
                        <Heading variant="subtitle1"><Translate value="uplevelRenewal.OnbrdPartnerFinderProductSoldSection" /></Heading>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section10} sectionName="section10" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <br/>
                        <Heading variant="subtitle1"><Translate value="uplevelRenewal.OnbrdPartnerFinderSrvcOfferedSection" /></Heading>
                        <b><Translate value="uplevelRenewal.AcctServicesOfferedErrorMsg" /></b>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section11} sectionName="section11" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                        <br/>
                        <Heading variant="subtitle1"><Translate value="uplevelRenewal.OnbrdPartnerFinderVerticalFocusSection" /></Heading>
                        <b><Translate value="uplevelRenewal.AcctVerticalSegmentErrorMsg" /></b>
                        <GridRow>
                            <GridColumn size={[12,6,6,6]} >
                                <DataSection formStates={this.props.formStates} form={formName} field={questions.section12} sectionName="section12" updateValidation={this.updateValidation}/>
                            </GridColumn>
                        </GridRow>
                    </GridColumn>
                </GridRow>
            </Grid>
            </div>
        }
        else{
            return <SaveNExit />
        }
    }
}

const Questionnaire2 = reduxForm({
    form:'uplevelRenewal',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(Questionnaire);

function mapStateToProps(state) {
return {
        formStates: getFormValues('uplevelRenewal')(state) // here 'form' is the name you have given your redux form 
}
}

export default connect(mapStateToProps)(Questionnaire2);